<template>
  <div class="discard-changes-modal rounded overflow-hidden text-dark bg-white p-3.5">
    <div class="discard-changes-modal__header flex items-center justify-between gap-3 mb-3.5">
      <div class="flex items-center gap-1">
        <svg width="16" height="17" fill="none">
          <use :xlink:href="`#circle-info`"></use>
        </svg>

        <h2 class="discard-changes-modal__title font-bold mb-0">Progress saved!</h2>
      </div>
      <button class="discard-changes-modal__close text-base" @click="close"><i class="icon-Close font-bold"></i></button>
    </div>
    <!-- body -->
    <div class="campaign-type-modal__body mb-3.5 leading-normal break-normal">Remember to complete the form later.</div>
    <!-- end body -->
    <div class="campaign-type-modal__footer-action flex justify-end items-center gap-2">
      <el-button class="font-semibold" @click="close">Keep editing</el-button>
      <el-button class="font-semibold ml-0" @click="discardChanges" type="primary">OK</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalDiscardChanges',
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    discardChanges() {
      this.close()
      if (this.meta && this.meta.backPath !== -1) {
        this.$router.push(this.meta.backPath)
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
